export enum CampaignPacingEnum {
  EvenlySpread = 0, // Daily campaign
  AsFastAsPossible = 1,
}
